// extracted by mini-css-extract-plugin
export default {"tooltip__name":"ElementTooltipName_tooltip__name__xM-Vs"};